// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { getProp } from "@insite/mobius/utilities";
import { floatingTooltipStyles } from "@steiner/App/Components/FloatingTooltip/FloatingTooltip";
import { color, getSystemColor } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

floatingTooltipStyles.tooltipContent = {
    css: css`
        background-color: ${color("common.ui1")};
        z-index: ${getProp("theme.zIndex.tooltip")};
        box-shadow: 0 2px 4px 0 ${color("common.ui7", 0.1)};
        padding: 12px;
        border-radius: 4px;
        max-width: 250px;
        border: 1px solid ${color("common.border", 0.5)};
    `,
};

floatingTooltipStyles.tooltipArrow = {
    width: 20,
    height: 14,
    fill: getSystemColor("common.ui1"),
    stroke: `${getSystemColor("common.ui7", 0.1)}`,
    strokeWidth: 1,
};
